import React from 'react'
import { observer } from 'mobx-react'
import { RootStore } from 'RootStore'
import { useDocumentTitle } from 'hooks/document-title'
import { Redirect } from 'react-router'
import link from 'infra/link'

interface Props {
  rootStore: RootStore
  match: any
}

export default observer(function Dashboard({ rootStore }: Props) {
  useDocumentTitle('Welcome')

  const isFirmAdmin = rootStore.jobRootViewModel.isFirmAdmin
  const canViewFirmDashboard =
    rootStore.firmDashboardViewModel.canViewFirmDashboard

  return (
    <Redirect
      to={
        isFirmAdmin && canViewFirmDashboard
          ? link.firmDashboard()
          : link.opportunities()
      }
      push={false}
    />
  )
})
